const Loader = ({ size = 40 }) => (
  <div className='flex justify-center items-center'>
    <div className='grid gap-2'>
      <div className='flex items-center justify-center '>
        <div className={`w-${size} h-${size} border-t-4 border-b-4 border-blue-400 rounded-full animate-spin`} />
      </div>
    </div>
  </div>
)

export default Loader
